import React from "react";
import { useArbeitszeitStore } from "../../../store/zustandArbeitszeitenStore";
import IWIstArbeitszeitenModal from "./IWIstArbeitszeitenModal";
import { globalMemory } from "../../../globals";
import { searchFilialtokenInArray } from "../../../utils/functions";

type IstArbeitszeitenModalWrapperProps = {
  handleIstZeitSubmit: (values: any) => void;
  filialToken: string[];
};

function IstArbeitszeitenModalWrapper(props: IstArbeitszeitenModalWrapperProps) {
  const detailDataIstArbeitszeiten = useArbeitszeitStore(state => state.detailDataIstArbeitszeiten);

  return (
    <IWIstArbeitszeitenModal
      submitAction={props.handleIstZeitSubmit}
      strVon={
        detailDataIstArbeitszeiten.extendedProps != undefined &&
        detailDataIstArbeitszeiten.extendedProps.detailZeiten.ist.von.length != 0
          ? detailDataIstArbeitszeiten.extendedProps.detailZeiten.ist.von
          : "" + searchFilialtokenInArray(globalMemory.oeffnungszeitenStammdaten, props.filialToken[0])?.oeffneUhrzeit
      }
      strBis={
        detailDataIstArbeitszeiten.extendedProps != undefined &&
        detailDataIstArbeitszeiten.extendedProps.detailZeiten.ist.bis.length != 0
          ? detailDataIstArbeitszeiten.extendedProps.detailZeiten.ist.bis
          : "" + searchFilialtokenInArray(globalMemory.oeffnungszeitenStammdaten, props.filialToken[0])?.schliesseUhrzeit
      }
      arrPausen={
        detailDataIstArbeitszeiten.extendedProps != null
          ? detailDataIstArbeitszeiten.extendedProps.detailZeiten.ist.pausen
          : []
      }
    />
  );
}

export default React.memo(IstArbeitszeitenModalWrapper);